var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"otherevent font-bunkyu-midashi"},[_c('p',[_vm._v("イベント")]),_c('div',{staticClass:"circles"},[_c('div',[_c('a',{attrs:{"href":"/event-detail/oc"}},[_vm._v("オープンキャンパス")])]),_c('div',[_c('a',{attrs:{"href":"/event-detail/geisai"}},[_vm._v("芸術祭")])]),_c('div',[_c('a',{attrs:{"href":"/event-detail/sotsusei"}},[_vm._v("卒業制作展")])])])])
}]

export { render, staticRenderFns }